export const VOUCHER_PAYMENTS_BASKET = {
  SET_CURRENT_BASKET_UUID: 'SET_CURRENT_BASKET_UUID'
};
